export enum eInventoryCheckState{
    'Creada' = 1,
    'En Proceso' = 2,
    'Finalizada' = 3,
    'Eliminada' = 4,
    'Cancelada' = 5,
}

export enum eTypeInventoryCheck{
    'Ciclicos' = 1,
}